import React from "react";
import { Image, Theme } from "@literati/public-ui-shared-react";
import { SubscriptionShippingWindow } from "@literati/kids-api";
import { PaymentParagraph } from "components/Payment/PaymentPrimitives";
import { getAbbrevDateString } from "utils/date";

const CLASS_BASE = "payment-section-expected-by";
export const PaymentSectionExpectedByClassName = {
  BASE: CLASS_BASE,
  PARAGRAPH: `${CLASS_BASE}-paragraph`,
  IMAGE: `${CLASS_BASE}-image`,
} as const;

export interface PaymentSectionExpectedByProps {
  shippingWindow: SubscriptionShippingWindow;
}

export const PaymentSectionExpectedBy = ({
  shippingWindow,
}: PaymentSectionExpectedByProps) => {
  const cls = PaymentSectionExpectedByClassName;
  const deliveryDate = getAbbrevDateString(shippingWindow[1], false);

  return (
    <Theme>
      <>
        <PaymentParagraph className={cls.PARAGRAPH}>
          Order today to get your reader’s first book box by{" "}
          <span>{deliveryDate}</span>
        </PaymentParagraph>
        <Image
          alt=""
          className={cls.IMAGE}
          contain
          css="flex-shrink: 0"
          src="https://siren-images.literati.com/images/rainbow_books_stack_butterfly.original.png"
          height={54}
          width={69}
        />
      </>
    </Theme>
  );
};

export default PaymentSectionExpectedBy;
